import { Component } from '@angular/core';
import { UserData } from '../../../../providers/user-data';
import { NavController, Events, LoadingController } from 'ionic-angular';
import { PageBase } from '../../../../core/page-base';
import { AppSettings } from '../../../../config/app-settings';
import { AboutUsCommon } from './about-us.common';
import { AboutUsData } from '../../providers/about-us-data';

@Component({
	selector: 'page-about-us',
	templateUrl: 'about-us.html'
})
export class AboutUsPage extends PageBase {
	public categories = [];

	public loader: any;
	public filteredItems: any;
	public pagedFilteredItems: any = [];
	public pageSize: Number = 15;
	public hasMore = true;
	public showCategoriesList = false;

	constructor(
		public nav: NavController,
		public userData: UserData,
		public settings: AppSettings,
		public common: AboutUsCommon,
		public events: Events,
		public aboutUsData: AboutUsData,
		public loadingCtrl: LoadingController
	) {
		super(settings, events, nav, userData);
		this.loader = this.loadingCtrl.create();
	}

	
	ngAfterViewInit() {
	}

	
	ionViewDidEnter() {
	}


}



// WEBPACK FOOTER //
// ./src/modules/about-us/pages/about-us/about-us.ts